import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/services/base.service';
import { DOC_STATE, PDF_CA, PDF_SLA } from 'src/app/constants/endpoint.const';
import { Subject, takeUntil } from 'rxjs';
import { ResponseCustomType } from 'src/app/types/response/response.type';
import { DocumentStateResponseType } from 'src/app/types/response/document-state.response.type';
import { NzMessageService } from 'ng-zorro-antd/message';
import { documentConfigs, documentDotStatusMap, documentStatusMap } from 'src/app/constants/documents.const';
import { DocumentConfigType } from 'src/app/models/documents.model';
import { ProfileService } from 'src/app/services/profile.service';
import { EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-shipping-delivery',
  templateUrl: './shipping-delivery.component.html',
  styleUrl: './shipping-delivery.component.scss'
})
export class ShippingDeliveryComponent {
  loading: boolean = true;
  destroy$ = new Subject();
  @Input() docState: DocumentStateResponseType[] = [];
  docSLA: string = '';
  docCA: string = '';
  docUAT: string = '';
  roLevel: string = '';
  @Output() stateUpdated = new EventEmitter<void>();

  documentConfigs: DocumentConfigType[] = documentConfigs;

  constructor(
    private router: Router,
    private BaseService: BaseService,
    private message: NzMessageService,
    private profileService: ProfileService
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.roLevel = String(this.profileService.getRoLevel() || '');
    this.profileService.getRoLevel$().subscribe((lvl) => {
      this.roLevel = String(lvl || '');
    });
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  handleAction(config: DocumentConfigType, mode: string) {
    const { route, type } = config;
    
    if (type === 'CA' && mode === 'create') {
      const slaState = this.getStateByType('SLA');
      if (!slaState || slaState.current_state === 1) {
        this.message.error('Please fill in SLA data first');
        return;
      }
    }

    localStorage.setItem(`mode-${type.toLowerCase()}-input`, mode);
    localStorage.setItem('service_type_doc', 'shipping');

    const queryParams: Record<string, string | number> = { service_type: 'shipping' };

    if (type === 'SLA' || type === 'UAT') {
      queryParams['step'] = 1;
    }

    if (mode === 'edit' && type !== 'UAT') {
      queryParams['mode'] = mode;
    }

    this.router.navigate([route], { queryParams });
  }

  sendDoc(type: string) {
    const route = type === 'SLA' ? '/document/submission-sla' : '/document/submission-ca';
    this.router.navigate([route], { queryParams: { service_type: 'shipping' } });
  }

  downloadPdf(v: string) {
    const url = v === 'SLA' ? PDF_SLA : PDF_CA
    this.BaseService.getData(url + '?service_types_id=1')
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.docSLA = res.data.uploaded_file_path
            window.open(this.docSLA, '_blank');
          this.updateState(v)
        },
        () => {
          this.message.create('error', 'The document is still in progress or has not been inputted yet');
        }
      );
  }

  getStateByType(type: string): DocumentStateResponseType | undefined {
    return this.docState.find((s) => s.document_type === type);
  }

  updateState(v: string): void {
    const params = {
      document_type: v,
      state: 3,
      service_types_id: 1,
    };
    this.BaseService.putData(DOC_STATE, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: ResponseCustomType<DocumentStateResponseType[]>) => {
          this.stateUpdated.emit();
        },
        (err) => {
          this.message.create('error', err.error.meta.message || 'Failed to update document state');
        }
      );
  }

  handleStatus(v: number | undefined) {
    return (v !== undefined && documentStatusMap[v]) || '';
  }

  handleDotStatus(v: number | undefined) {
    return (v !== undefined && documentDotStatusMap[v]) || '';
  }
}
